import { useAuth } from '@/lib/auth/react';
import { useAuthenticationMe } from '@/lib/endpoints';
import type { ResolvedTerritory } from './types';

const BYPASS_AUTH = import.meta.env.VITE_BYPASS_AUTH === 'true';

/**
 * The resolved-territory verdict from `/auth/me`. Read via a cast until the
 * Orval client carries `territory` (see lib/territory/types). Returns null when
 * unauthenticated or before `/me` has loaded — callers treat null as "unknown,
 * not yet blocking" (the server gate is the authority).
 */
export function useTerritory(): ResolvedTerritory | null {
  const { isAuthenticated } = useAuth();
  const me = useAuthenticationMe({ query: { enabled: !BYPASS_AUTH && isAuthenticated } });
  const data = me.data as { territory?: ResolvedTerritory } | undefined;
  return data?.territory ?? null;
}

/** Convenience: is the user currently blocked from gated actions by territory rules? */
export function useTerritoryBlocked(): boolean {
  return useTerritory()?.blocked ?? false;
}

/** Category codes to hide for the current user (country ∪ state). */
export function useHiddenCategories(): string[] {
  return useTerritory()?.hiddenCategories ?? [];
}
